import { Grid, Typography } from '@mui/material';
import React from 'react';

import BgImage from '../../../assets/assetmark/bg-image.png';
import { useSlideContext } from '../../context';
import styles from './styles.module.css';

export type TitleSlideTemplateState = {
  title: string;
};

export type TitleSlideTemplateProps = {
  readonly state: TitleSlideTemplateState;
  readonly setState: (state: TitleSlideTemplateState) => void;
  readonly editable?: boolean;
};

export function TitleSlideTemplate({
  state,
}: TitleSlideTemplateProps): React.ReactElement {
  const { theme } = useSlideContext();

  return (
    <Grid
      container
      className={styles.slide}
      style={{ backgroundImage: `url(${BgImage})` }}
    >
      <Grid item justifyContent="center" alignItems="center">
        <Typography
          sx={{
            fontSize: theme.fontSize.title,
            color: theme.colors.white,
            fontFamily: theme.fontFamily.headings,
            fontWeight: theme.fontWeight.bold,
          }}
        >
          {state.title}
        </Typography>
      </Grid>
    </Grid>
  );
}
